import { useMemo, useCallback } from 'react';

import validationMethods from 'js/utils/Validation/validationMethods';

export const useGetAscendingOrderLimitError = ({ fields, eq, error, exceptions }) => {
    const validateAscendingOrder = useMemo(
        () => validationMethods.ascending({
            ...fields && { fields },
            ...eq && { eq },
            ...error && { error },
            ...exceptions && { exceptions }
        }),
        [fields, eq, error, exceptions]
    );

    return useCallback(({ values }) => {
        const valuesToValidate = Object.fromEntries(
            Object.entries(values)
                .filter(([fieldName]) => fields.includes(fieldName))
                .map(([fieldName, value]) => [fieldName, Number(String(value).replace(',', '.'))])
        );

        const validationWarnings = Object.entries(valuesToValidate)
            .map(([fieldName, value]) => validateAscendingOrder(value, valuesToValidate, fieldName))
            .filter(Boolean);

        if (!validationWarnings.length) {
            return null;
        }

        return validationWarnings[0];
    }, [validateAscendingOrder, fields]);
};
